/**
 * Mark Price proxy API (GET /api/mark-price/history)
 */

import { API_CONFIG } from '@/config/api';
import { apiFetch } from '@/lib/apiFetch';

const BASE = API_CONFIG.MARK_PRICE_PATH_PREFIX;

export interface MarkPriceCandle {
  ts_ms: number;
  open: number;
  high: number;
  low: number;
  close: number;
}

export interface MarkPriceHistoryResponse {
  exchange: string;
  symbol: string;
  interval: string;
  count: number;
  data: MarkPriceCandle[];
}

export type MarkPriceExchange = 'bybit' | 'okx' | 'binance' | 'gateio' | 'bitget';

export interface MarkPriceHistoryParams {
  exchange: MarkPriceExchange;
  symbol: string;
  hours?: number;
  interval?: string;
  start_ts?: number;
  end_ts?: number;
  limit?: number;
}

export async function getMarkPriceHistory(params: MarkPriceHistoryParams): Promise<MarkPriceHistoryResponse> {
  const q = new URLSearchParams();
  q.set('exchange', params.exchange);
  q.set('symbol', params.symbol.trim());
  if (params.hours != null) q.set('hours', String(params.hours));
  if (params.interval != null) q.set('interval', params.interval);
  if (params.start_ts != null) q.set('start_ts', String(params.start_ts));
  if (params.end_ts != null) q.set('end_ts', String(params.end_ts));
  if (params.limit != null) q.set('limit', String(params.limit));

  const res = await apiFetch(`${BASE}/history?${q.toString()}`, { method: 'GET' });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || `HTTP ${res.status}`);
  }
  return res.json() as Promise<MarkPriceHistoryResponse>;
}
